export enum LibraryTypes {
  SetLibraryObjectLandingQuery = 'Library.SetLibraryObjectLandingQuery',
}

export type Value<T> = { filter: T; search: string };
export type LibraryTableFilterOptionValueType =
  | 'all'
  | 'metrics'
  | 'funnels'
  | 'retention'
  | 'segments'
  | 'heatmaps'
  | 'dashboards'
  | 'starred'
  | 'recent'
  | 'mine'
  | 'private'
  | 'hasInsights';

export enum FilterOptionValueEnum {
  active = 'active',
  archived = 'archived',
  recent = 'recent',
  starred = 'starred',
  mine = 'mine',
  private = 'private',
  hasInsights = 'hasInsights',
}
export type FilterOptionValueType = keyof typeof FilterOptionValueEnum;

export type ControlValue = Value<FilterOptionValueType>;

export type LibraryState = ControlValue;
